import script from "./pcNav.vue?vue&type=script&setup=true&lang=js"
export * from "./pcNav.vue?vue&type=script&setup=true&lang=js"

import "./pcNav.vue?vue&type=style&index=0&id=5dbed89b&lang=scss"
import "./pcNav.vue?vue&type=style&index=1&id=5dbed89b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dbed89b"]])

export default __exports__